import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useForm } from "react-hook-form";
import { zodResolver } from "@hookform/resolvers/zod";
import { z } from "zod";
import { Helmet } from "react-helmet-async";
import type { User } from "@wishlist-hub/shared";
import { Button, Card, ErrorText, Input, Label } from "../components/ui";
import { api } from "../services/api";
import { useAuthStore } from "../stores/authStore";

const schema = z.object({
  email: z.string().email(),
  password: z.string().min(6),
  name: z.string().min(1).max(50),
});

export function Register() {
  const nav = useNavigate();
  const setUser = useAuthStore((s) => s.setUser);
  const [err, setErr] = useState("");
  const f = useForm<z.infer<typeof schema>>({ resolver: zodResolver(schema) });

  const onSubmit = f.handleSubmit(async (v) => {
    setErr("");
    try {
      const { data } = await api.post<{ user: User }>("/auth/register", v);
      setUser(data.user);
      nav("/profile");
    } catch (e: unknown) {
      const msg =
        typeof e === "object" && e && "response" in e
          ? String((e as { response?: { data?: { error?: { message?: string } } } }).response?.data?.error?.message)
          : "";
      setErr(msg || "Ошибка регистрации");
    }
  });

  return (
    <>
      <Helmet>
        <title>Регистрация — WishList Hub</title>
      </Helmet>
      <Card className="max-w-md mx-auto">
        <h1 className="text-xl font-semibold text-white">Регистрация</h1>
        <form className="mt-4 space-y-3" onSubmit={onSubmit}>
          <div>
            <Label>Имя</Label>
            <Input {...f.register("name")} autoComplete="name" />
          </div>
          <div>
            <Label>Email</Label>
            <Input type="email" {...f.register("email")} autoComplete="email" />
          </div>
          <div>
            <Label>Пароль</Label>
            <Input type="password" {...f.register("password")} autoComplete="new-password" />
          </div>
          {err && <ErrorText>{err}</ErrorText>}
          <Button type="submit" className="w-full" disabled={f.formState.isSubmitting}>
            Создать аккаунт
          </Button>
        </form>
        <p className="mt-4 text-center text-sm text-slate-500">
          Уже есть аккаунт? <Link to="/auth/login" className="text-violet-400">Вход</Link>
        </p>
      </Card>
    </>
  );
}
